<template lang="pug">
  DefaultLayout
    AccountDetail
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import AccountDetail from '@/components/AccountDetail.vue';

export default {
  name: 'AccountDetailPage',
  components: { DefaultLayout, AccountDetail },
};
</script>
